export const UNASSIGNED = 'unassigned@nisl.org';
export const NOT_REQUIERD = 'not_required@nisl.org';
